import React from "react";
import { Button } from "@networkraildigitalfactory/components";

const CreateOneToOneButtons = (props) => {
  const { status, saveOneToOne, isDisableActions, isDirtyForm, onSubmit } = props;
  let isDisabled = !isDirtyForm;

  if (isDisableActions) {
    isDisabled = true;
  }

  switch (status) {
    case "new":
      return (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            color={isDisabled ? "grey" : "blue"}
            text="Save as draft"
            name="save as draft"
            onClick={saveOneToOne}
            disabled={isDisabled}
          />
          <Button
            color={isDisabled ? "grey" : "green"}
            text="Submit prep"
            name="submit prep"
            disabled={isDisabled}
            onClick={onSubmit}
          />
        </div>
      );
    default:
      return <></>;
  }
};
export default CreateOneToOneButtons;
